/*
 * @Author: cn1994
 * @Date: 2024-11-14 17:46:07
 * @LastEditors: cn1994
 * @LastEditTime: 2024-11-27 14:31:24
 * @Description: 约课相关路由
 */

const routes = [
  // 约课管理首页
  {
    path: '/appointmentCourse',
    name: 'appointmentCourse',
    meta: {
      title: '约课管理',
      volcengine: true,
    },
    component: () => import('@/pages/appointment/manage/index.vue')
  },
  // 老师可约时间
  {
    path: '/appointmentCourse/teacherAvailableTime',
    name: 'appointmentCourse/teacherAvailableTime',
    meta: {
      title: '老师可约时间管理',
      volcengine: true,
    },
    component: () => import('@/pages/appointment/teacher/index.vue')
  },
]

export default routes